import apiUrl from '../../../constants';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import keycloak from "../../../Keycloak"

export default {
    name: 'login',
    components: {
        Loading
    },
    props: [],
    data() {
        return {
            isLoading: false,
            ums_url: apiUrl.ums_url,
        }
    },
    created: function () {
    },

    computed: {

    },
    mounted() {

    },
    methods: {
        trigger: function () {
            this.checklogin();
        },
        checklogin() {
            keycloak.login();
        },
    }
}



// WEBPACK FOOTER //
// ./src/views/components/login/login.component.js